<mat-list-item
  *ngIf="menuItem.isAuthorized"
  [disabled]="!menuItem.isActiveFeature"
  [title]="
    !menuItem.isActiveFeature ? 'Fonctionnalité non disponible' : menuItem.title
  "
>
  <div
    class="layout-drawer-item"
    [ngClass]="{ inactive: !menuItem.isActiveFeature }"
  >
    <mat-icon mat-list-icon>{{ menuItem.icon }}</mat-icon>
    <a mat-line [routerLink]="menuItem.isActiveFeature ? menuItem.link : null">
      {{ menuItem.title }}
    </a>
  </div>
</mat-list-item>
